export const CREATE_INTRO_FIRST_STEP_ONBOARDING_STATE_KEYS = {
	headerSeenAt: 'create-intro-first-step:headerSeenAt',
	headerCompleted: 'create-intro-first-step:headerCompleted',
	headerDismissed: 'create-intro-first-step:headerDismissed',
} as const;

export const CreateIntroFirstStepOnboardingStateKeys: readonly (
	| 'create-intro-first-step:headerSeenAt'
	| 'create-intro-first-step:headerCompleted'
	| 'create-intro-first-step:headerDismissed'
)[] = Object.values(CREATE_INTRO_FIRST_STEP_ONBOARDING_STATE_KEYS);
